import {initDonationInlineComponents} from './donation.js';
import {initNewsletterInlineComponents} from './newsletter.js';
import {initPetitionInlineComponents} from './petition.js';
import {initPollInlineComponents} from './poll.js';
import {initPublicationInlineComponents} from './publication.js';
import {initInlineOfferTracking} from './tracking.js';

export function initInlineComponents(root = document) {
  initInlineOfferTracking(root);
  initNewsletterInlineComponents(root);
  initPetitionInlineComponents(root);
  initPollInlineComponents(root);
  initPublicationInlineComponents(root);
  void initDonationInlineComponents(root);
}
